import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileBarChart } from "lucide-react";
import api from "@/lib/api";
import { REPORT_STATUSES } from "@/pages/cm/AnalyseBlocks";

export default function LastReportCard({ clientId }) {
  const [rep, setRep] = useState(undefined);
  const navigate = useNavigate();
  useEffect(() => {
    api.get(`/clients/${clientId}/reports`)
      .then((r) => setRep((r.data || [])[0] || null))
      .catch(() => setRep(null));
  }, [clientId]);
  if (rep === undefined) return null;
  const st = rep ? (REPORT_STATUSES[rep.status] || REPORT_STATUSES.genere) : null;
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-2xl p-5" data-testid="last-report-card">
      <h3 className="font-heading font-bold mb-3 flex items-center gap-2">
        <FileBarChart className="w-4 h-4 text-neutral-400" /> Dernier rapport CM
      </h3>
      {!rep ? (
        <>
          <p className="text-sm text-neutral-400 mb-3">Aucun rapport généré pour ce client.</p>
          <button onClick={() => navigate(`/cm?tab=analyse&client=${clientId}&sub=rapports`)}
            data-testid="last-report-goto"
            className="text-xs font-semibold text-[#0369A1] hover:underline">Générer le premier rapport →</button>
        </>
      ) : (
        <div className="space-y-2">
          <p className="text-sm font-semibold text-[#0F172A] capitalize">{rep.period_label}</p>
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`text-[10px] font-semibold rounded-full px-2 py-0.5 border ${st.cls}`} data-testid="last-report-status">{st.label}</span>
            {rep.published_at && (
              <span className="text-[11px] text-neutral-400">
                publié le {new Date(rep.published_at).toLocaleDateString("fr-FR")}
              </span>
            )}
          </div>
          <button onClick={() => navigate(`/cm/rapport/${rep.id}`)} data-testid="last-report-open"
            className="text-xs font-semibold text-[#0369A1] hover:underline">Consulter →</button>
        </div>
      )}
    </div>
  );
}
